import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/site";
import { useReveal } from "../hooks/useReveal";
import FlyWords from "./FlyWords";

export default function Testimonials() {
  const ref = useReveal();
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="section bg-[#0a0a0a] relative"
      ref={ref}
    >
      <div className="container-x">
        <div className="max-w-3xl mb-14 reveal">
          <div className="overline mb-5">Kind words</div>
          <FlyWords
            as="h2"
            className="font-display text-4xl md:text-5xl lg:text-6xl text-white font-light leading-tight"
            segments={[{ text: "What our clients say." }]}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="surface p-8 reveal flex flex-col"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <Quote className="h-7 w-7 text-[#D4AF37] mb-5" />
              <blockquote className="font-display text-xl md:text-2xl text-white leading-snug flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-[#27272A]">
                <div className="text-white text-sm font-medium">{t.name}</div>
                <div className="text-xs text-[#A1A1AA] mt-0.5">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
